import i18next from '../../config/i18next';
import i18nError from './i18n/fr.json';
import ErrorBoundary from './components/error-boundary/error-boundary';
import ErrorPage from './pages/error-page/error-page';

i18next.addResourceBundle('fr', 'error', i18nError);

export { ErrorBoundary, ErrorPage };
